export default function toggleHeader() {
  const header = document.querySelector('.js-header');
  const fixedHeader = document.querySelector('.js-fixedHeader');

  const onIntersect = (entries) => {
    entries.forEach((entry) => {
      fixedHeader.setAttribute('aria-hidden', entry.isIntersecting);
    });
  };

  const observer = new IntersectionObserver(onIntersect);
  observer.observe(header);
}
